<template>
  <div class="review-card">
    <div class="review-card__inner">
      <div class="review-card__head">
        <v-lazy-image v-if="review.avatar"
                      :src="review.avatar"
                      :title="createTitleMixin(`Review from '${fullName}`)"
                      :alt="createAltMixin(`Review from '${fullName}`)"
                      class="review-card__img"
                      use-picture>
          <source :srcset="review.avatar_webp"
                  type="image/webp">
        </v-lazy-image>
        <div v-else
             class="review-card__img   _placeholder">
          {{ getPhotoTextPlaceholder() }}
        </div>
        <div class="review-card__head-main">
          <div class="review-card__name">{{ fullName }}</div>
          <router-link-modified v-if="review.work_in"
                                :to="vacanciesWithCountryRoute"
                                class="review-card__work-in">
            {{ $tHome('Work in') }}
            <div :style="`background-image: url(${review.work_in.flag})`"
                 class="review-card__flag"></div>
          </router-link-modified>
        </div>
      </div>
      <div class="review-card__footer">
        <div class="review-card__rating-wrap">
          <div class="review-card__rating  rating">
            <BaseSvg v-for="i in 5"
                     :key="i"
                     name="ico-star"
                     :date-active="(i <= review.rating).toString()"/>
          </div>
        </div>
        <time :datetime="datetime">{{ review.review_date | formatDate }}</time>
      </div>
      <div class="review-card__text text">
        <p>{{ review.review_text }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import parseDateForLocal from '@/helpers/parseDateForLocal'
  import {mapState} from 'vuex'

  export default {
    name: 'ReviewCard',
    props: {
      review: Object,
      default: () => {
        return {
          name: '',
          surname: '',
        }
      }
    },
    data() {
      return {}
    },
    computed: {
      ...mapState('vacancies', [
        'staticFiltersKeys',
      ]),
      fullName() {
        return `${this.review.firstname} ${this.review.lastname}`.trim()
      },
      datetime() {
        return parseDateForLocal(this.review.review_date).toISOString()
      },
      vacanciesWithCountryRoute() {
        return {
          name: 'vacancies-with-static',
          params: {
            staticFilters: [`${this.staticFiltersKeys.COUNTRY}-${this.review.work_in.id}`]
          }
        }
      }
    },
    methods: {
      getPhotoTextPlaceholder() {
        const name = this.review.firstname || ''
        const surname = this.review.lastname || ''
        return (surname.slice(0, 1) + name.slice(0, 1)).toUpperCase()
      }
    },
  }
</script>

<style lang="less">

</style>